import React from 'react';
import BarLine from '../common/graphs/barLineNew';
import SimpleIndicator from '../common/indicators/simpleIndicator';

const Bar = props => (
  <div className={`main_summary_graph__color ${props.width}`}>
    <div className="tour-aux-light-area indicator-distribution-tour"/>
    {props.showTravelInfo && (
      <div className="travel-idicators">
        <SimpleIndicator
          value={props.drivenKms}
          valueFormat={{ type: 'NUMBER', format: '.0f', sufix: ' Km' }}
        />
        <SimpleIndicator
          value={props.drivenHours}
          valueFormat={{ type: 'NUMBER', format: '.0f', sufix: ' Hrs' }}
        />
      </div>
    )}
    <a className="normal" data-tags={false}>
      {props.distribution && (
        <BarLine
          name="severity"
          value="driversQuantity"
          distribution={props.distribution}
          language={props.language.summary.graphTooltip}
        />
      )}
    </a>
    {props.text && (
      <div className="distribution-chart-info">
        <h3>{props.language.summary.behaviour.resultsDistribution}</h3>
        <div className="modal-indicators-info">
          <a className="green">
            <i className="fas fa-question-circle" />
            <div>            
              <p>{props.language.summary.behaviour.distHelp1}</p>
              <p>{props.language.summary.behaviour.distHelp2}</p>
              <p>
                <span className="green">
                {props.language.summary.graphTooltip.OUTOFRISK + ": "}
                </span> 
                {props.language.summary.behaviour.between + " " + props.graphColorRange.outOfRisk[0] + " " + props.language.summary.behaviour.to + " 100"}
              </p>
              <p>
                <span className="yellow">
                {props.language.summary.graphTooltip.MIDDLERISK + ": "}
                </span> 
                {props.language.summary.behaviour.between + " " + (props.graphColorRange.middleRisk[0]+1) + " " + props.language.summary.behaviour.to + " " + props.graphColorRange.middleRisk[1]}
              </p>
              <p>
                <span className="red">
                {props.language.summary.graphTooltip.HIGHRISK + ": "}
                </span> 
                {props.language.summary.behaviour.between + " " + (props.graphColorRange.higherRisk[0]+1) + " " + props.language.summary.behaviour.to + " " + (props.graphColorRange.higherRisk[1])}
              </p>
            </div>
          </a>
        </div>
      </div>
    )}
  </div>
);

export default Bar;



// WEBPACK FOOTER //
// ./source/client/components/summary_behaviour/bar.jsx